import faker from '@faker-js/faker';
import loopMap from 'mn-utils/loopMap';
import {TListItem, TMetrics} from './types';
import {TListItem as TRefund} from '../refunds/types';
import {getRefundList} from '../refunds/mock';

export const getPayByLinkList = (limit: number): TListItem[] => {
  return loopMap(limit, () => {
    return getDetails();
  });
};

export const getMetrics = (): TMetrics => {
  return {
    sent: faker.mersenne.rand(999),
    paid: faker.mersenne.rand(999),
    canceled: faker.mersenne.rand(999),
    expired: faker.mersenne.rand(999),
    pending: faker.mersenne.rand(999),
  } as TMetrics;
};

export const getDetails = (): TListItem => {
  const statuses = ['sent', 'paid', 'canceled', 'expired', 'pending'];
  return {
    invoice_id: faker.datatype.uuid(),
    buyer_name: faker.name.findName(),
    buyer_address: faker.address.streetAddress(true),
    email: faker.internet.email(),
    invoice_number: faker.datatype.uuid(),
    order_id: faker.datatype.uuid(),
    invoice_dt: '' + faker.date.recent().toISOString(),
    invoice_fiat_amount: faker.finance.amount(0, 1000, 2),
    invoice_fiat_code: faker.finance.currencyCode(),
    status: (faker.helpers as any).arrayElement(statuses),
    payment_id: faker.datatype.uuid(),
    payment_dt: faker.date.recent().toISOString(),
    fiat_amount: faker.finance.amount(0, 1000, 2),
    fiat_code: faker.finance.currencyCode(),
    cc_amount: faker.finance.amount(0, 1000, 2),
    cc_code: faker.finance.currencyCode(),
    files: [
      {
        id: faker.datatype.uuid(),
        doc_type: faker.system.fileExt(),
        file_name: faker.system.fileName(),
      },
      {
        id: faker.datatype.uuid(),
        doc_type: faker.system.fileExt(),
        file_name: faker.system.fileName(),
      },
      {
        id: faker.datatype.uuid(),
        doc_type: faker.system.fileExt(),
        file_name: faker.system.fileName(),
      },
    ],
    refunds: getRefundList(faker.mersenne.rand(3)) as TRefund[],
  } as TListItem;
};

export const getMinimalAmount = (): {amount: string} => {
  return {
    amount: String(faker.finance.amount(0, 10, 2)),
  } as {amount: string};
};
